import * as firebase from 'firebase'
import { Store } from 'vuex';
import Vue from "vue"

export default {
  state: {
      nodes:[
        {index:0,name:"Experts",pos:{x:680,y:0},offset:{x:0,y:0},selected:false,children:[]},
        {index:1,name:"Documents",pos:{x:720,y:140},offset:{x:0,y:0},selected:false,children:[]},
        {index:2,name:"Environment",label:"Locations",pos:{x:700,y:280},offset:{x:0,y:0},selected:false,children:[]},
        {index:3,name:"Evidence",label:"Evidence",pos:{x:680,y:420},offset:{x:0,y:0},selected:false,children:[]}
        
            ],
        offset:{x:0,y:0}
      },
  mutations: {
    resetNodes(state){
      for(var i in state.nodes){
        state.nodes[i].children=[]
      }
    },
    setNodes(state,payload){
      let name
      let id
      let node
      let obj

      for(var i in state.nodes){
        
        if(state.nodes[i].name==payload.type ){
          console.log("SET NODES",payload,state.nodes[i])
          for(var j in payload.content){  
            node=payload.content[j].split(" ")
            obj={id:node[0],index:parseInt(j,10)}
            if(node.length>1){
              node.shift()
              obj.name=node.join(" ")
            }
            
            let childExists=false
            for(var c in state.nodes[i].children){
              if(state.nodes[i].children[c].id == obj.id){
                childExists=true
              }
            }
            if(!childExists){
              console.log(" ++++++  NEW OBJ",obj)

              //obj.read=false
              state.nodes[i].children.push(obj) 
            }
          }
         console.log("SET NODES",state.nodes[i].children)
        }
      }
     
    },
    setOffset(state,payload){
        state.offset=payload
    },
    setNodeOffset(state,payload){
        state.nodes[payload.index].offset={x:payload.x,y:payload.y}
    },
    
  },
  actions: {
   
  },
  getters: {
      getNodeOffset: state => index => {
            return state.nodes[index].offset || {x:0,y:0}
      },
      getOffset(state){
          return state.offset
      },
      getNodes(state){
        return state.nodes
      },
     
  }
}

